import axiosInstance from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { METHOD_TYPES } from 'utils/constants/index'

export const getMyBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/fast-games/air-goal/my-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getTopBetsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/fast-games/air-goal/get-top-win', {}, {
    params,
    server: microServices.USER_URL
  })
}
